<template>
  <v-layout column>
    <!-- Include categories component -->
    <clubhouse-categories2 @category-selected="onCategorySelected"></clubhouse-categories2>

    <v-flex class="_clubhouse-category--articles-section">
      <v-container grid-list-xl>
        <v-layout row wrap>
          <v-flex v-for="item in articles" :key="'art__' + item.id" xs12 md4>
            <app-card-article2 :item="item"></app-card-article2>
          </v-flex>

          <v-flex v-if="articles.length === 0" xs12 text-xs-center mt-5>
            <h3>No article is favourite in this category</h3>
          </v-flex>

          <!-- Pagination -->

          <v-flex v-if="pagination.last_page > 1" xs12 text-xs-center my-5>
            <v-pagination v-model="currentPage" class="app-pagination" :length="pagination.last_page"
              :total-visible="5" />
          </v-flex>



        </v-layout>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
import clubhouseCategories2 from '../../clubhouse/share/clubhouse-categories2.vue';
import axios from "axios";
// import appCardArticle from '../../../../components/app-card/app-card-article.vue';
import AppCardArticle2 from '../../../../components/app-card/app-card-article2.vue';

export default {
  name: "AppSaved",
  components: {
    clubhouseCategories2,
    AppCardArticle2
  },
  data() {
    return {
      articles: [],
      selectedCategoryId: null,
      currentPage: 1,
      pagination: {
        last_page: 1,
        per_page: 9,
        total: 0
      }
    };
  },

  watch: {
    currentPage(newPage) {
      if (this.selectedCategoryId) {
        this.fetchArticles(this.selectedCategoryId, newPage)
      }
    }
  },

  methods: {

    async onCategorySelected(categoryId) {
      this.selectedCategoryId = categoryId
      this.currentPage = 1 // reset to first page
      await this.fetchArticles(categoryId, this.currentPage)
    },

    async fetchArticles(categoryId, page = 1) {
      try {
        const token = localStorage.getItem("_token")

        const response = await axios.get(`/favorites/category/${categoryId}/0`, {
          headers: {
            Authorization: `Bearer ${token}`
          },
          params: {
            page: page,
            per_page: this.pagination.per_page
          }
        })

        const data = response.data
        this.articles = data.data || []
        this.pagination.total = data.total || 0
        this.pagination.last_page = data.last_page || 1
        this.pagination.per_page = data.per_page || 9
      } catch (err) {
        console.error("API Error:", err.response ? err.response.data : err.message)
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/app/favourites/shared/AppSaved.vue